export default __webpack_public_path__ + "static/media/gallery_03.1fdb1d1a.jpg";